if (!customElements.get('faq-accordion')) {
  customElements.define(
    'faq-accordion',
    class FaqAccordion extends HTMLElement {
      connectedCallback() {
        this.singleOpen = this.dataset.singleOpen === 'true';
        this.rows = Array.from(this.querySelectorAll('details.faq-accordion__details'));

        this.onToggle = this.onToggle.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);

        this.rows.forEach((row) => row.addEventListener('toggle', this.onToggle));
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.rows.forEach((row) => row.removeEventListener('toggle', this.onToggle));
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      onToggle(event) {
        const opened = event.target;
        if (!this.singleOpen || !opened.open) return;

        this.rows.forEach((row) => {
          if (row !== opened) row.open = false;
        });
      }

      // Opens the matching row when a merchant selects a block in the theme editor.
      onBlockSelect(event) {
        const row = event.target.querySelector('details.faq-accordion__details');
        if (!row || !this.contains(row)) return;
        row.open = true;
      }
    }
  );
}
